import { render, staticRenderFns } from "./DedicatePage3.vue?vue&type=template&id=4ba928ba&scoped=true&"
import script from "./DedicatePage3.vue?vue&type=script&lang=js&"
export * from "./DedicatePage3.vue?vue&type=script&lang=js&"
import style0 from "./DedicatePage3.vue?vue&type=style&index=0&id=4ba928ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba928ba",
  null
  
)

export default component.exports